import { getStringFromId } from "helpers/vernacular";
import { VERNACULAR_DEFAULT_MESSAGES, VERNACULAR_STRING_IDS } from "constants/vernacularConstants";
import { IUPIInfo } from "@nykaa/payment-sdk/src/Payment/@types";
import { get } from "logics/src/utils/helpers";
import { toLowerCase } from "helpers/utils/toLowerCase";
import { getIcons, ICONS_NAMES } from "helpers/utils/getIcons";
import { ACCORDIAN, DEVICE_TYPE } from "constants/index";
import { PAYMENT_METHODS } from "constants/payment";
import { PAYMENT_SCREENS } from "constants/paymentScreens";
import { doAppendQueryParam } from "../../../helpers";
import { isServer } from "helpers/utils/isServer";
import { formatNumber } from "helpers/utils/numberFormatter";

/** COD helper */
/**
 * @description -- function that takes codNudge as input and maniputes it's text  string
 * and returns manipulated nudge details
 */
export const getNudgeConfig = ({
  grandTotal,
  codNudge,
  codHandlingCharge,
  toggleAccordian,
  trackCODNudgeCtaClick,
  setIsCodMethodSelected,
  newPaymentMethodWithPriority,
  newPaymentMethod,
  deviceType,
  platform,
  paymentScreen,
  history,
  disableNudge,
  theme,
}: any) => {
  let nudgeConfig = {
    nudgeLeadingIcon: "",
    nudgeText: "",
    nudgeCtaClickable: false,
    nudgeMode: "",
    nudgeCtaText: "",
    nudgeBoldText: "",
    nudgeHtmlText: "",
    showNudgeBackground: false,
    nudgeCtaHTMLText: "",
    ctaEndIcon: "",
    /**
     * function to handle the nudge cta click
     */
    onNudgeCtaClick: () => {
      /**
       * change the payment mode if it is present in existing payment modes and ctaClickable is true on nudge cta click
       */
      let paymentMethods = Object.values(ACCORDIAN);
      if (codHandlingCharge) {
        /**
         * if user click on switch to prepaid CTA
         * then show then first payment option to
         * user
         * if cod on first place then show second
         * payment option to user.
         */
        if (deviceType === DEVICE_TYPE.DESKTOP) {
          if (newPaymentMethod?.length > 0) {
            let firstOption = newPaymentMethod[0];
            if (firstOption === ACCORDIAN.COD && newPaymentMethod.length > 1) {
              toggleAccordian(newPaymentMethod[1]);
            } else {
              toggleAccordian(firstOption);
            }
          }
        } else {
          let paymentMethodlength = newPaymentMethodWithPriority?.length;

          /**
           * when only cod shown on saved payment screen then on prepaid cta click
           * redirect user to new payment method screen.
           * or If there is upi alerting and moving
           * upi to bottom then on prepaid cta click
           * redirect user to new payment method screen.
           */
          if (
            paymentScreen === PAYMENT_SCREENS.SAVED &&
            (newPaymentMethodWithPriority.length === 1 ||
              (newPaymentMethodWithPriority.length > 1 &&
                newPaymentMethodWithPriority[1].isAlertshowing))
          ) {
            let url = doAppendQueryParam("screen", "newPayment");
            history.push(url);
            return;
          }

          if (paymentMethodlength > 0) {
            if (
              newPaymentMethodWithPriority[0]?.method === ACCORDIAN.COD &&
              paymentMethodlength > 1
            ) {
              toggleAccordian(newPaymentMethodWithPriority[1]?.method);
            } else {
              toggleAccordian(newPaymentMethodWithPriority[0]?.method);
            }
          }
        }
        setIsCodMethodSelected(false);
      } else if (
        paymentMethods.length &&
        paymentMethods.includes(codNudge?.mode) &&
        codNudge?.ctaClickable
      ) {
        toggleAccordian(codNudge.mode);
        //cod nudge cta click--->
        trackCODNudgeCtaClick(codNudge.ctaText);
      }
    },
  };

  /**
   * if showing nudge is disable
   */
  if(disableNudge){
    return nudgeConfig;
  }

  /**
   * in case order amount is zero then we are not showing cash handling charges and cod nudge.
   */
  if (grandTotal === 0) return nudgeConfig;

  /**
   * priority of codHandlingCharge is greater then cod nudge
   */
  if (codHandlingCharge) {
    nudgeConfig.nudgeText = getStringFromId(
      VERNACULAR_STRING_IDS.DYNAMIC_COD_HANDLING_TEXT,
      `A <strong style = "font-weight:600">₹${formatNumber(codHandlingCharge)} cash handling fee </strong> will be charged on this order.`,
      { codHandlingCharge: codHandlingCharge }
    );
    nudgeConfig.nudgeBoldText = "true";
    nudgeConfig.nudgeCtaClickable = true;
    nudgeConfig.showNudgeBackground = true;
    nudgeConfig.nudgeCtaHTMLText = getStringFromId(
      VERNACULAR_STRING_IDS.DYNAMIC_COD_HANDLING_CTA_TEXT,
      `<strong style = 'font-weight:600; color:${theme.brandPrimary}' > Switch to prepaid method, save ₹${formatNumber(codHandlingCharge)} </strong> &nbsp;`,
      { color: theme.brandPrimary, codHandlingCharge: codHandlingCharge }
    );
    nudgeConfig.ctaEndIcon = getIcons(platform, ICONS_NAMES.RIGHT_ARROW);
  } else if (codNudge?.messages?.text) {
    /**
     * Don't show cod nudge on saved payment screen.
     */
    if (paymentScreen === PAYMENT_SCREENS.SAVED && deviceType === DEVICE_TYPE.MOBILE) {
      return nudgeConfig;
    }

    nudgeConfig.nudgeText = codNudge?.messages?.text;
    nudgeConfig.nudgeLeadingIcon = codNudge?.imageIcon;
    nudgeConfig.nudgeCtaClickable = codNudge?.ctaClickable;
    nudgeConfig.nudgeMode = codNudge?.mode;
    nudgeConfig.nudgeCtaText = codNudge?.ctaText;
    nudgeConfig.nudgeBoldText = codNudge?.messages?.boldText || "";
  }

  if (nudgeConfig.nudgeText && nudgeConfig.nudgeBoldText) {
    nudgeConfig.nudgeHtmlText = nudgeConfig.nudgeText.replace(
      nudgeConfig.nudgeBoldText,
      `<strong style = 'font-weight:600'>${nudgeConfig.nudgeBoldText}</strong>`
    );
  }
  return nudgeConfig;
};

/** UPI helpers */

export const getTransformedVpaList = (vpaSuffixList: string[]) => {
  try {
    if (!isServer()) {
      const finalVpaSuffixList = vpaSuffixList.map(value => ({
        text: value,
      }));
      return finalVpaSuffixList;
    }
  } catch (error) {
    // logger.error(error, 'Error in getTransformedVpaList');
  }
  return vpaSuffixList;
};

/**
 * @description
 * function that gets vpa details from upiMapping
 * @param vpaHandle
 * @param upiMapping
 */
export const getVpaDetails = (vpaHandle: string, upiMapping?: IUPIInfo[]) => {
  let vpaDetails = {
    title: "BHIM UPI",
    vpa: vpaHandle || "",
    icon: "https://adn-static1.nykaa.com/media/wysiwyg/UPI_Icons/UPI.svg",
    notifyIcon: "https://adn-static1.nykaa.com/media/wysiwyg/UPI_Icons/Notify.svg",
    completeIcon: "https://adn-static1.nykaa.com/media/wysiwyg/UPI_Icons/Done.svg",
    message: "Check for “Payment Request” from <b>FSN BRANDS MARKETING LIMITED</b>",
  };

  let response = {
    showSavedVpa: false,
    ...vpaDetails,
  };

  if (Array.isArray(upiMapping) && upiMapping.length) {
    upiMapping.forEach(upiMappingValue => {
      const {
        title,
        vpaSuffix,
        iconIntentUrl,
        iconNotifyUrl,
        completeIcon,
        notifyMessage,
      } = upiMappingValue;

      if (vpaHandle) {
        const userVpaSuffix = vpaHandle.substr(vpaHandle.indexOf("@") + 1);
        if (vpaSuffix.includes(userVpaSuffix)) {
          vpaDetails = {
            title,
            vpa: vpaHandle,
            icon: iconIntentUrl,
            notifyIcon: iconNotifyUrl,
            completeIcon,
            message: notifyMessage,
          };

          response = {
            showSavedVpa: true,
            ...vpaDetails,
          };
        }
      }
    });
  }
  return response;
};

/**
 *
 * @param upiMode selected upi from upi icons in new upi layout
 * @returns list of vpa handle suffix
 * @description remoteConfig: {
 * ...
 *  configs: {
 *    ...
 *    payment: {
 *      vpaSuffixList: {
 *        "phonePe": ["@ybl", "@axl", "@ibl","Other UPI"],
 *        "googlePay": ["@okicici", "@oksbi","okaxis","@okhdfcbank","Other UPI"],
 *        "paytm": ["@paytm"],
 *      }
 *    }
 *    ...
 * }
 * ...
 * }
 */

export const getVpaSuffixList = (upiMode: string) => {
  let vpaSuffixList = []; //'@ybl', '@axl'
  try {
    if (!isServer()) {
      const { remoteConfig } = window as any;
      const list = get(remoteConfig, `configs.payment.vpaSuffixList.${upiMode}`);
      if (list) {
        vpaSuffixList = list;
      }
    }
  } catch (error) {
    // logger.error(error, 'Error in getVpaSuffixList');
  }

  return vpaSuffixList;
};

/**
 *
 * @param selectedUpi selected upi from the list of UPI Icons
 * @param vpa selected vpa suffix from drop down
 * @returns transformed vpa
 */

export const validateInputOnVpaChange = (selectedUpi: string, vpa: string) => {
  if (selectedUpi == ACCORDIAN.UPI) {
    return vpa;
  } else if (vpa && vpa.includes("@")) {
    let newVpa = vpa.substring(0, vpa.indexOf("@"));
    return newVpa;
  }

  return vpa;
};

/**
 *
 * @param selectedUpi selected upi from the list of UPI Icons
 * @param vpa selected vpa suffix from drop down
 * @returns transformed vpa
 */

export const validateVpaHandle = (selectedUpi: string, vpa: string) => {
  try {
    if (selectedUpi == ACCORDIAN.UPI) {
      return vpa;
    } else if (vpa && vpa.includes("@")) {
      let newVpa = vpa.substring(0, vpa.indexOf("@"));
      return newVpa;
    }
  } catch (error) {
    // logger.error(error, 'Error in validateVpaHandle');
  }

  return vpa;
};

/**
 *
 * @param vpaSuffixList list of exiting vpa suffix
 * @param vpa entered vpa id as input
 * @returns vpaId and vpaSuffix of entered vpa if matched otherwise only returns vpa and suffix will be empty for further action.
 */

export const getSeparatedUpiDataForMatchedSuffix = (vpaSuffixList: string[], vpa: string) => {
  try {
    if (vpa && vpa.includes("@")) {
      let pivoteIndex = vpa.indexOf("@");
      let vpaId = vpa.substring(0, pivoteIndex);
      let vpaSuffix = vpa.substring(pivoteIndex);

      if (vpaSuffixList.includes(vpaSuffix)) {
        return {
          vpaId,
          vpaSuffix,
        };
      }
    }
  } catch (error) {
    // logger.error(error, 'Error in getSeparatedUpiDataForMatchedSuffix');
  }

  return {
    vpaId: vpa,
    vpaSuffix: "",
  };
};

/**
 *
 * @param vpa entered vpa id as input
 * @returns vpaId and vpaSuffix of entered vpa for further action.
 */

export const getSeparatedUpiData = (vpa: string) => {
  try {
    if (vpa && vpa.includes("@")) {
      let pivoteIndex = vpa.indexOf("@");
      let vpaId = vpa.substring(0, pivoteIndex);
      let vpaSuffix = vpa.substring(pivoteIndex);
      return {
        vpaId,
        vpaSuffix,
      };
    }
  } catch (error) {
    // logger.error(error, 'Error in getSeparatedUpiData');
  }

  return {
    vpaId: vpa,
    vpaSuffix: "",
  };
};

// const translations = getCurrentLangStrings();

/**
 *
 * @param selectedUpi argument of selected upi from list of UPI icons
 * @description getUpiInfoDetails to get the details of selected upi info to show in the bottomsheet.
 * @returns details to show in the upi Info bottomsheet
 */

export const getUpiInfoDetails = (selectedUpi: string) => {
  switch (selectedUpi) {
    case PAYMENT_METHODS.GOOGLE_PAY:
      return {
        title: getStringFromId(
          VERNACULAR_STRING_IDS.DYNAMIC_WHERE_CAN_FIND_UPI_ID,
          "Steps to find your Google pay UPI Id",
          { appName: "Google Pay" }
        ),
        step1: getStringFromId(
          VERNACULAR_STRING_IDS.DYNAMIC_OPEN_YOUR_APP,
          "1. Open your Google Pay App",
          { appName: "Google Pay" }
        ),
        step2: getStringFromId(
          VERNACULAR_STRING_IDS.TAP_ON_PROFILE_ICON_RIGHT,
          VERNACULAR_DEFAULT_MESSAGES.TAP_ON_PROFILE_ICON_RIGHT
        ),
        step3: getStringFromId(
          VERNACULAR_STRING_IDS.FIND_UPI_ID,
          VERNACULAR_DEFAULT_MESSAGES.FIND_UPI_ID
        ),
        image1: getIcons("", ICONS_NAMES.ALL_UPI_PROFILE_GOOGLEPAY),
        image2: getIcons("", ICONS_NAMES.ALL_FIND_UPI_ID_GOOGLEPAY),
      };
    case PAYMENT_METHODS.PHONE_PE:
      return {
        title: getStringFromId(
          VERNACULAR_STRING_IDS.DYNAMIC_WHERE_CAN_FIND_UPI_ID,
          "Steps to find your PhonePe UPI Id",
          { appName: "PhonePe" }
        ),
        step1: getStringFromId(
          VERNACULAR_STRING_IDS.DYNAMIC_OPEN_YOUR_APP,
          "1. Open your PhonePe App",
          { appName: "PhonePe" }
        ),
        step2: getStringFromId(
          VERNACULAR_STRING_IDS.TAP_ON_PROFILE_ICON_LEFT,
          VERNACULAR_DEFAULT_MESSAGES.TAP_ON_PROFILE_ICON_LEFT
        ),
        step3: getStringFromId(
          VERNACULAR_STRING_IDS.FIND_PHONEPE_UPI_ID,
          VERNACULAR_DEFAULT_MESSAGES.FIND_PHONEPE_UPI_ID
        ),
        image1: getIcons("", ICONS_NAMES.ALL_UPI_PROFILE_PHONEPE),
        image2: getIcons("", ICONS_NAMES.ALL_FIND_UPI_ID_PHONEPE),
      };
    case PAYMENT_METHODS.PAYTM:
      return {
        title: getStringFromId(
          VERNACULAR_STRING_IDS.DYNAMIC_WHERE_CAN_FIND_UPI_ID,
          "Steps to find your Paytm UPI Id",
          { appName: "Paytm" }
        ),
        step1: getStringFromId(
          VERNACULAR_STRING_IDS.DYNAMIC_OPEN_YOUR_APP,
          "1. Open your Paytm App",
          { appName: "Paytm" }
        ),
        step2: getStringFromId(
          VERNACULAR_STRING_IDS.TAP_ON_PROFILE_ICON_LEFT,
          VERNACULAR_DEFAULT_MESSAGES.TAP_ON_PROFILE_ICON_LEFT
        ),
        step3: getStringFromId(
          VERNACULAR_STRING_IDS.FIND_UPI_ID,
          VERNACULAR_DEFAULT_MESSAGES.FIND_UPI_ID
        ),
        image1: getIcons("", ICONS_NAMES.ALL_UPI_PROFILE),
        image2: getIcons("", ICONS_NAMES.ALL_FIND_UPI_ID),
      };
    case PAYMENT_METHODS.UPI:
      return {
        title: getStringFromId(
          VERNACULAR_STRING_IDS.DYNAMIC_WHERE_CAN_FIND_UPI_ID,
          "Steps to find your UPI ID",
          { appName: " " }
        ),
        step1: getStringFromId(
          VERNACULAR_STRING_IDS.DYNAMIC_OPEN_YOUR_APP,
          "1. Open your UPI App",
          { appName: "UPI" }
        ),
        step2: getStringFromId(
          VERNACULAR_STRING_IDS.TAP_ON_PROFILE_ICON,
          VERNACULAR_DEFAULT_MESSAGES.TAP_ON_PROFILE_ICON
        ),
        step3: getStringFromId(
          VERNACULAR_STRING_IDS.FIND_UPI_ID,
          VERNACULAR_DEFAULT_MESSAGES.FIND_UPI_ID
        ),
        image1: getIcons("", ICONS_NAMES.ALL_UPI_PROFILE),
        image2: getIcons("", ICONS_NAMES.ALL_FIND_UPI_ID),
      };
    default:
      return {
        title: getStringFromId(
          VERNACULAR_STRING_IDS.DYNAMIC_WHERE_CAN_FIND_UPI_ID,
          "Steps to find your UPI ID",
          { appName: " " }
        ),
        step1: getStringFromId(
          VERNACULAR_STRING_IDS.DYNAMIC_OPEN_YOUR_APP,
          "1. Open your UPI App",
          { appName: "UPI" }
        ),
        step2: getStringFromId(
          VERNACULAR_STRING_IDS.TAP_ON_PROFILE_ICON,
          VERNACULAR_DEFAULT_MESSAGES.TAP_ON_PROFILE_ICON
        ),
        step3: getStringFromId(
          VERNACULAR_STRING_IDS.FIND_UPI_ID,
          VERNACULAR_DEFAULT_MESSAGES.FIND_UPI_ID
        ),
        image1: getIcons("", ICONS_NAMES.ALL_UPI_PROFILE),
        image2: getIcons("", ICONS_NAMES.ALL_FIND_UPI_ID),
      };
  }
};

/** NB helpers */

export const getBankImage = (bankName: string): string => {
  const bank = toLowerCase(bankName);
  switch (bank) {
    case "axis":
      return getIcons("", ICONS_NAMES.AXIS);
    case "hdfc":
      return getIcons("", ICONS_NAMES.HDFC);
    case "icici":
      return getIcons("", ICONS_NAMES.ICICI);
    case "kotak":
      return getIcons("", ICONS_NAMES.KOTAK);
    case "sbi":
      return getIcons("", ICONS_NAMES.SBI);
    case "yes":
      return getIcons("", ICONS_NAMES.YES_BANK);
    case "other bank":
      return getIcons("", ICONS_NAMES.OTHER_BANK);
    default:
      return getIcons("", ICONS_NAMES.OTHER_BANK);
  }
};

/**
 * @description It is for get the masked number (format 98xxxxxx09)
 * @param mobile
 * @returns masked mobile number
 */
export const getMaskedPhoneNumber = (mobile: any) => {
  const phone = mobile?.toString();
  if (phone?.length === 10) {
    return `${phone[0]}${phone[1]}xxxxxx${phone[8]}${phone[9]}`;
  }
  return mobile;
};
